import { crud, http } from "../../../libs/react-mpk/services";
import qs from "query-string";

let service = new crud("/");

export const getDataBupot = (query, fgLapor) => {
  query["fgLapor.equals"] = fgLapor
  return http.get(`/support/sb`, query);
};

export const getSyncBulk = (data) => {
  return http.get(`/support/sb/syncBupot/bulk?${qs.stringify(data)}`);
};

export const getSyncBulkByid = (id) => {
  return http.get(`/support/sb/syncBupot/single/${id}`);
};

export const getFormatReport= (tipeModel,tipeFile,query) => {
  return http.download(`/support/sb/report/${tipeModel}/${tipeFile}?${qs.stringify(query)}`);
};
export const getDataBupotById = (id, query) => {
  return http.get(`/support/sb/${id}`, query);
};

export const addDataBupot = (data) => {
  return http.post(`/support/sb`, data);
};

export const deleteBupot  = (id, data) => {
  return http.delete(`/support/sb/${id}`, data);
};

export const updateBupot  = (id, data) => {
  return http.put(`/support/sb/${id}`, data);
};


export default service;